import request from '@/utils/request';

/**
 * 创建悬浮图标配置
 * @param {Object} params 请求参数
 * @param {string} [params.act_id] 活动ID
 * @param {string} params.can_be_disable yes 可以 no 不可以
 * @param {number} params.end_at 展示结束时间 -1 永久展示
 * @param {string} params.image_url 图片URL
 * @param {string} params.jump_type link 链接 act 平台活动
 * @param {string} [params.jump_url] 跳转链接
 * @param {string} [params.open_type] new_tab 新页签 embed 内嵌
 * @param {number} [params.sort] 排序
 * @param {number} params.start_at 展示开始时间
 * @param {string} params.url_type inner 站内 outer 站外 none 无
 * @returns {Promise} 返回Promise对象
 */
export function createFloatingIcon(params) {
  return request({
    url: '/api/v1/admin/game_config/floating_icon/create',
    method: 'post',
    data: params
  });
}

/**
 * 删除悬浮图标配置
 * @param {Object} params 请求参数
 * @param {number} params.id 主键id
 * @returns {Promise} 返回Promise对象
 */
export function deleteFloatingIcon(params) {
  return request({
    url: '/api/v1/admin/game_config/floating_icon/delete',
    method: 'post',
    data: params
  });
}

/**
 * 获取悬浮图标配置详情
 * @param {Object} params 请求参数
 * @param {number} params.id 主键id
 * @returns {Promise} 返回Promise对象
 */
export function getFloatingIconDetail(params) {
  return request({
    url: '/api/v1/admin/game_config/floating_icon/get',
    method: 'post',
    data: params
  });
}

/**
 * 获取悬浮图标配置列表
 * @param {Object} params 请求参数
 * @param {number} [params.end_at] 展示结束时间
 * @param {number} params.page 当前页码
 * @param {number} params.page_size 每页条数
 * @param {number} [params.start_at] 展示开始时间
 * @param {string} [params.status] enabled 启用 disabled 禁用
 * @returns {Promise} 返回Promise对象
 */
export function getFloatingIconList(params) {
  return request({
    url: '/api/v1/admin/game_config/floating_icon/list',
    method: 'post',
    data: params
  });
}

/**
 * 更新悬浮图标配置
 * @param {Object} params 请求参数
 * @param {string} [params.act_id] 活动id 当jump_type为act时有效
 * @param {string} [params.can_be_disable] yes 可以 no 不可以
 * @param {number} [params.end_at] 展示结束时间
 * @param {number} params.id 主键id
 * @param {string} [params.image_url] 图片URL
 * @param {string} [params.jump_type] 跳转类型 link 链接 act 平台活动
 * @param {string} [params.jump_url] 跳转链接
 * @param {string} [params.open_type] new_tab 新页签 embed 内嵌
 * @param {number} [params.sort] 排序 越小越靠前
 * @param {number} [params.start_at] 展示开始时间
 * @param {string} [params.status] enabled 启用 disabled 禁用
 * @param {string} [params.url_type] inner 站内 outer 站外 none 无
 * @returns {Promise} 返回Promise对象
 */
export function updateFloatingIcon(params) {
  return request({
    url: '/api/v1/admin/game_config/floating_icon/update',
    method: 'post',
    data: params
  });
}

